import React, { useState } from 'react';
import { Formik, FormikValues } from 'formik';

import { apiHost, commonHeaders } from '../../../config';

import FormikInputField from '../ui/FormikInputField/Input';
import Button from '../ui/Button/Button';
import PopupForm from '../ui/PopupForm/Form';
import PopupFormHeader from '../ui/PopupForm/Header';
import PopupFormErrorMessage from '../ui/PopupForm/ErrorMessage';

import styles from './LoginForm.module.scss';

interface Props {
  darkenBg?: boolean;

  onSuccess: (response?: any) => void;
}

const LoginForm = ({ darkenBg, onSuccess }: Props) => {
  const [error, setError] = useState<string | null>(null);

  const initialValues = {
    username: '',
    password: '',
  };

  const submit = async (values: FormikValues) => {
    const { username, password } = values;

    const body = JSON.stringify({ username, password });
    const headers = commonHeaders;
    const method = 'POST';
    const url = `${apiHost}/api/login`;

    const response = await fetch(url, { method, body, headers });

    if (response.status === 422) setError('Неправильный логин или пароль');
    if (response.status === 500)
      setError('Ошибка на сервере. Попробуйте позже');
    if (!response.ok) return;

    const json = await response.json();
    if (!json.token) return;

    try {
      localStorage.username = username;
      localStorage.token = `Bearer ${json.token}`;
      onSuccess(json);
    } catch (e) {
      setError((e as Error).message);
    }
  };

  return (
    <Formik initialValues={initialValues} onSubmit={submit}>
      <PopupForm className={styles.popup_login_form} darkenBg={darkenBg}>
        <PopupFormHeader>
          ВХОД
          <PopupFormErrorMessage visible={error !== null} text={error ?? ''} />
        </PopupFormHeader>

        <FormikInputField
          name="username"
          placeholder="Логин"
          onFocus={() => setError(null)}
        />

        <FormikInputField
          name="password"
          type="password"
          placeholder="Пароль"
          onFocus={() => setError(null)}
        />

        <Button type="submit">Подтвердить</Button>
      </PopupForm>
    </Formik>
  );
};

LoginForm.defaultProps = {
  darkenBg: true,
};

export default LoginForm;
